interface RetryActionProps {
  disabled: boolean;
  onRetry: () => Promise<void>;
}

export function RetryAction({ disabled, onRetry }: RetryActionProps) {
  return (
    <div className="retry-action">
      <button
        disabled={disabled}
        onClick={() => void onRetry()}
      >
        Retry
      </button>
    </div>
  );
}
